import {MediaQuery} from '@optimaxdev/design-system';

import {useMediaQuery} from 'react-responsive';

/**
 * Custom hook for truncate text
 * @params {text}:string
 * @returns {string}
 */
export const useTruncateText = (text: string): string => {
    const isSmallScreen = useMediaQuery(MediaQuery.sm);

    const getMaxLetters = () => (isSmallScreen ? 34 : 39);

    const maxLetters = getMaxLetters();

    if (text.length > maxLetters) {
        return `${text.slice(0, maxLetters).replace(/\s+$/g, '')}... `;
    }

    return `${text}${' '}`;
};
